// src/pages/dashbord/section/InboundSection.tsx
import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import InboundModal from '../../../components/InboundModal';
import InboundKPI from '../../../components/InboundKPI';
import InboundSplitDonut from '../../../components/InboundSplitDonut';
import InboundAllTimeChart from '../../../components/InboundAllTimeChart';
import InboundTable from '../../../components/InboundTable';
import InboundsExportButton from '../../../components/InboundsExportButton';
import StatusChips from '../../../ui/StatusChips';
import TableHeader from '../../../components/TableHeader';

type Props = {
  filteredInbounds: any[];
  inboundSeries: Array<{ date: string; count: number; cumulative: number }>;
  inboundStatusLineCounts: Record<string, number>;
  inboundActiveStatuses: string[];
  onToggleInboundStatus: (key: string) => void;
  inboundSearch: string;
  onInboundSearchChange: (s: string) => void;
  onResetColumns: () => void;
  rowsCount: number;
  colsVer: number;
  INBOUND_META: ReadonlyArray<{ key: string; label: string; fg: string; bg: string }>;
  onInboundCreated?: () => void;
};

const InboundSection: React.FC<Props> = ({
  filteredInbounds,
  inboundSeries,
  inboundStatusLineCounts,
  inboundActiveStatuses,
  onToggleInboundStatus,
  inboundSearch,
  onInboundSearchChange,
  onResetColumns,
  rowsCount,
  colsVer,
  INBOUND_META,
  onInboundCreated,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div style={{ marginTop: 16 }}>
        <InboundKPI source={filteredInbounds as any} />
      </div>

      <Row gutter={[16, 16]} style={{ marginTop: 28 }}>
        <Col xs={24} md={12} lg={10}>
          <InboundSplitDonut height={420} rangeDays={30} />
        </Col>
        <Col xs={24} md={12} lg={14}>
          <InboundAllTimeChart data={inboundSeries} height={420} />
        </Col>
      </Row>

      <Card
        variant="borderless"
        className="stat-card stat-card--accent-blue"
        style={{ marginTop: 16 }}
        styles={{ header: { paddingTop: 14, paddingBottom: 14, alignItems: 'center' } }}
  title={
          <TableHeader
            icon={<InboxOutlined />}
            title="Поступления"
            chips={
              <StatusChips
                metas={INBOUND_META.map(s => ({ key: s.key, label: s.label, bg: s.bg, fg: s.fg }))}
                counts={inboundStatusLineCounts}
                activeKeys={inboundActiveStatuses}
                onToggle={onToggleInboundStatus}
                hideZero
              />
            }
            totalLabel="Все поступления"
            totalValue={rowsCount}
            searchPlaceholder="№ поступления / SKU / Поставщик"
            searchValue={inboundSearch}
            onSearchChange={onInboundSearchChange}
            onResetColumns={onResetColumns}
            exportButton={<InboundsExportButton className="header-action-btn" source={filteredInbounds as any[]} />}
          />
        }
      >
        <InboundTable key={colsVer} inbounds={filteredInbounds as any} maxRows={Number.POSITIVE_INFINITY} />
      </Card>

      <InboundModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreated={() => { setModalOpen(false); onInboundCreated?.(); }}
      />
    </>
  );
};

export default InboundSection;
